import styled from 'styled-components'
import _ from 'lodash'

import { FlexProps } from '../Flex'
import { Link } from '../Link'
import { Space } from '../Space'
import { themeColor, themeSpace } from '../theme'

const NavPillsContainer = styled(Space)`
  flex-direction: column;
`

const Pill = styled.div<{ active?: boolean }>`
  border-radius: 4px;

  background: ${({ active }) => themeColor(active ? 'primary' : 'bgSecondary')};
  color: ${({ active }) => themeColor(active ? 'white' : 'textPrimary')};
  padding: ${themeSpace(1)} ${themeSpace(2)};

  font-weight: ${({ active }) => (active ? 'bold' : 'normal')};
`

export type NavPillsItem = { text: string; page: string; active?: boolean }

export interface NavPillsProps extends FlexProps {
  items: NavPillsItem[]
}

export const NavPills = ({ items }: NavPillsProps) => {
  return (
    <NavPillsContainer space={1} direction="vertical">
      {_.map(items, (item, i) => (
        <Link to={item.page} key={i}>
          <Pill active={item.active}>{item.text}</Pill>
        </Link>
      ))}
    </NavPillsContainer>
  )
}
